import type { UseQueryResult } from "@tanstack/react-query";

import { useOrgScopedQuery } from "../../query/scope";
import { fetchOrgTemplate } from "./api";
import type { BranchTemplateSettingsResponse } from "./api";

// Org-состояние шаблона + легенда плейсхолдеров + пресеты одним GET.
export function useOrgTemplate(): UseQueryResult<
  BranchTemplateSettingsResponse,
  Error
> {
  return useOrgScopedQuery<BranchTemplateSettingsResponse>({
    key: ["branchNameTemplate", "org"],
    queryFn: () => fetchOrgTemplate(),
    retry: false,
  });
}
